import ToolTip from '../../../ui/ToolTip'
import * as React from 'react'
import { Route, Link, RouteComponentProps } from 'react-router-dom'
import Edit from '../../../icons/ui/Edit'
import { IActiveTripResponseV2, ITripStatus, IStateUser } from '../../../../types'

interface IPickupNoteProps {
  actionUrl: string
}

interface IPickupNoteState {
  isModalOpen: boolean
}

export default class PickupNote extends React.Component<IPickupNoteProps, IPickupNoteState> {
  constructor(props: any) {
    super(props)

    this.state = {
      isModalOpen: false
    }
  }
  public render() {
    return (
      <React.Fragment>
        <Link to={this.props.actionUrl}>
          <button type='button' className='note-button note-button:hover'>
            <span>
              <ToolTip message={'Edit'}>
                <Edit className='icon--small svg-stroke-grey3' />
              </ToolTip>
            </span>
          </button>
        </Link>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/note-modal/PickupNote.tsx